import React from 'react';
import PropTypes from 'prop-types';

import Asterisk from '../Asterisk';
import Box from '../Box';
import Label from '../Label';
import Select from './Select';


const SelectWithLabel = (props) => {
  const {
    isRequired,
    label,
    ...rest
  } = props;

  return (
    <Box sx={{ width: '100%' }}>
      <Label
        sx={{
          color: 'fieldLabel',
          fontSize: 'font14',
        }}
      >
        {label}
        {isRequired && (
          <React.Fragment>
            {` `}
            <Asterisk />
          </React.Fragment>
        )}
      </Label>
      <Select {...rest} isRequired={isRequired} sx={{ marginTop: 'grid4' }} />
    </Box>
  );
};

SelectWithLabel.propTypes = {
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  setRef: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
  value: PropTypes.string,
};

SelectWithLabel.defaultProps = {
  isRequired: undefined,
  onChange: undefined,
  setRef: undefined,
  value: undefined,
};

const SelectWithLabelWithRef = React.forwardRef((props, ref) => (
  <SelectWithLabel setRef={ref} {...props} />
));


export { SelectWithLabel };
export default SelectWithLabelWithRef;
